<template>
    <div class="mainBox" :style="{height: height}">
        <iframe width="100%" height="100%" v-if="station" :src="`/yangchen_station/?windowSize=big&station_id=${station.station_id}&uid=1526&showMap=0&timep=${timeType}&data_type=${dataType}&t=${station.data.time}&show_childs=${showChilds}&start=${$moment(valueTime[0]).unix()}&end=${$moment(valueTime[1]).unix()}&data_calied_type=${calied_type}`" />
        <a v-if="$is_dock_env" @click="ecsqp" title="退出全屏" style="position: absolute; top: 25px; right: 75px; width: 20px; height: 20px; dispaly: block; background: url('/nuofang-wz-api/webfron/wz/pc/sites/pollution_index/static/icon/tcqp.png'); background-size: 100% 100%; z-index: 9999"></a>
        <a v-else @click="ecsqp" title="退出全屏" style="position: absolute; top: 25px; right: 75px; width: 20px; height: 20px; dispaly: block; background: url('http://webfron.czczh.net/wz/pc/sites/pollution_index/static/icon/tcqp.png'); background-size: 100% 100%; z-index: 9999"></a>
        <i @click="close" class="el-icon-close" style="position: absolute; top: 25px; right: 45px"></i>
    </div>
</template>

<script>
import { type } from 'os'
export default {
    name: 'BigStationDialog',
    props: {
        station: {
            type: Object
        },
        timeType: {
            type: String
        },
        dataType: {
            type: String
        },
        showChilds: {
            type: Number
        },
        height: {
            type: String
        },
        map: {
            type: Object
        },
        valueTime: {
          type: Array
        },
        calied_type: {
          type: Number
        }
    },
    watch: {
        station() {
            console.log(this.station)
        }
    },
    methods: {
        close() {
            this.map.closeInfoWindow()
            this.$emit('changeBigStationDialogShow', false)
        },
        ecsqp() {
            this.$emit('changeBigStationDialogShow', false)
        }
    }
}
</script>

<style scoped>
    .mainBox {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        background: #fff;
        z-index: 999;
    }
</style>


// WEBPACK FOOTER //
// src/components/BigStationDialog.vue